module.exports = __webpack_public_path__ + "static/media/add.655b93b4.svg";